/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Form_LabelInputs */

const en_insert_speaker_form_label = /** @type {(inputs: Insert_Speaker_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker insertion form`)
};

const fr_insert_speaker_form_label = /** @type {(inputs: Insert_Speaker_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire d'insertion de locuteur`)
};

const de_insert_speaker_form_label = /** @type {(inputs: Insert_Speaker_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautsprechereinführungsformular`)
};

const it_insert_speaker_form_label = /** @type {(inputs: Insert_Speaker_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo di inserimento dell'altoparlante`)
};

const ru_insert_speaker_form_label = /** @type {(inputs: Insert_Speaker_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма для добавления докладчика`)
};

const es_insert_speaker_form_label = /** @type {(inputs: Insert_Speaker_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de inserción de oradores`)
};

const zh_cn2_insert_speaker_form_label = /** @type {(inputs: Insert_Speaker_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发言人录入表`)
};

const ja_insert_speaker_form_label = /** @type {(inputs: Insert_Speaker_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカー挿入フォーム`)
};

const hi_insert_speaker_form_label = /** @type {(inputs: Insert_Speaker_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर सम्मिलन प्रपत्र`)
};

const pt_pt2_insert_speaker_form_label = /** @type {(inputs: Insert_Speaker_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulário de inserção de alto-falante`)
};

/**
* | output |
* | --- |
* | "Speaker insertion form" |
*
* @param {Insert_Speaker_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_form_label = /** @type {((inputs?: Insert_Speaker_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_speaker_form_label(inputs)
	if (locale === "de") return de_insert_speaker_form_label(inputs)
	if (locale === "it") return it_insert_speaker_form_label(inputs)
	if (locale === "ru") return ru_insert_speaker_form_label(inputs)
	if (locale === "es") return es_insert_speaker_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_speaker_form_label(inputs)
	if (locale === "ja") return ja_insert_speaker_form_label(inputs)
	if (locale === "hi") return hi_insert_speaker_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_speaker_form_label(inputs)
	return en_insert_speaker_form_label(inputs)
});